import React, { useState } from "react";
import useTracker from "hooks/useTracker";

import PayNowModal from "./payNowModal";

const formatAmount = (amount) => {
    if (!amount) return { display: "0", full: "0.00" };

    const num = parseFloat(amount);
    if (num >= 10000000) {
        return {
            display: `${(num / 10000000).toFixed(2)} Cr`,
            full: num.toLocaleString("en-IN", { maximumFractionDigits: 2 }),
        };
    }
    if (num >= 100000) {
        return {
            display: `${(num / 100000).toFixed(2)} L`,
            full: num.toLocaleString("en-IN", { maximumFractionDigits: 2 }),
        };
    }
    if (num >= 1000) {
        return {
            display: `${(num / 1000).toFixed(2)} K`,
            full: num.toLocaleString("en-IN", { maximumFractionDigits: 2 }),
        };
    }
    return {
        display: num.toLocaleString("en-IN", { maximumFractionDigits: 2 }),
        full: num.toLocaleString("en-IN", { maximumFractionDigits: 2 }),
    };
};

const NewOutstandingCard = ({ creditDetails, mandiName = "", mandiId = "" }) => {
    const [openPayNow, setOpenPayNow] = useState(false);
    const [showFullAmount, setShowFullAmount] = useState(false);
    const trackUser = useTracker();

    if (!creditDetails) return null;

    const outstanding = parseFloat(creditDetails.customer_outstanding || 0);
    const creditLimit = parseFloat(creditDetails.credit_limit || 0);
    const drawingPower = parseFloat(creditDetails.drawing_power || 0);
    const effectiveCreditLimit = Math.min(creditLimit, drawingPower);
    const calculatedOverdue = outstanding - effectiveCreditLimit;
    const overdueAmount = calculatedOverdue > 0 ? calculatedOverdue : 0;

    const { display: outstandingDisplay, full: outstandingFull } = formatAmount(outstanding);
    const { display: creditLimitDisplay } = formatAmount(effectiveCreditLimit);

    const isOverLimit = outstanding > effectiveCreditLimit;

    const backgroundGradient = isOverLimit
        ? "linear-gradient(89.6deg, #FEF3F2 0.25%, #FFFFFF 99.6%)"
        : "linear-gradient(89.6deg, #DEFBF9 0.25%, #FFFFFF 99.6%)";

    const handlePayNowClick = (e) => {
        e.stopPropagation();
        setOpenPayNow(true);
        trackUser("PayNowButtonClick");
    };

    const handleCardClick = (e) => {
        if (e.target.closest("button")) return;
        setShowFullAmount((prev) => !prev);
    };

    return (
        <>
            <div
                onClick={handleCardClick}
                style={{
                    width: "100%",
                    borderRadius: "16px",
                    background: backgroundGradient,
                    boxShadow: "0px 11.53px 51.3px 0px #0000001F",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "20px 16px",
                    cursor: "pointer",
                }}
            >
                {/* Outstanding Section - Left */}
                <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                    <div
                        style={{
                            fontFamily: "Manrope",
                            fontSize: "14px",
                            fontWeight: 900,
                            color: "#6b7c94",
                        }}
                    >
                        Outstanding
                    </div>
                    <div style={{ display: "flex", alignItems: "baseline" }}>
                        <span
                            style={{
                                fontFamily: "Roboto",
                                fontSize: "20px",
                                fontWeight: 400,
                                color: "#DB2A2A",
                                marginRight: "2px",
                            }}
                        >
                            ₹
                        </span>
                        <span
                            style={{
                                fontFamily: "Manrope",
                                fontSize: "20px",
                                fontWeight: 700,
                                color: "#DB2A2A",
                            }}
                        >
                            {showFullAmount ? outstandingFull : outstandingDisplay}
                        </span>
                    </div>
                </div>

                {/* Credit Limit Section - Middle (hidden when showFullAmount is true) */}
                {!showFullAmount && (
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "6px" }}>
                        <div
                            style={{
                                fontFamily: "Manrope",
                                fontSize: "14px",
                                fontWeight: 500,
                                color: "#6b7c94",
                            }}
                        >
                            Credit limit
                        </div>
                        <div style={{ display: "flex", alignItems: "baseline", gap: "8px" }}>
                            <span
                                style={{
                                    fontFamily: "Manrope",
                                    fontSize: "16px",
                                    fontWeight: 400,
                                    color: "#9CA3AF",
                                }}
                            >
                                /
                            </span>
                            <span
                                style={{
                                    fontFamily: "Manrope",
                                    fontSize: "20px",
                                    fontWeight: 800,
                                    color: "#717989",
                                }}
                            >
                                ₹ {creditLimitDisplay}
                            </span>
                        </div>
                    </div>
                )}

                {/* Pay Now Button - Right */}
                <button
                    type="button"
                    onClick={handlePayNowClick}
                    style={{
                        padding: "12px 20px",
                        borderRadius: "999px",
                        background: "#FF6A00",
                        color: "#fffbf8",
                        border: "none",
                        fontFamily: "Manrope",
                        fontSize: "12px",
                        fontWeight: 900,
                        cursor: "pointer",
                        whiteSpace: "nowrap",
                    }}
                >
                    PAY NOW
                </button>
            </div>

            <PayNowModal
                open={openPayNow}
                setOpenPayNow={setOpenPayNow}
                isMandiActive
                mandiName={mandiName || creditDetails.name || ""}
                mandiId={mandiId}
                overdueAmount={overdueAmount}
                outStandingAmount={outstanding}
            />
        </>
    );
};

export default NewOutstandingCard;
